import { useSelector } from 'react-redux';
// Org-level beta gating, sourced from PartySettings via getActiveOrg and cached
// in localStorage.
//
// Receiving (ReceivingV2) / put-away (PutAwayV2): an org may use them only at
// facilities listed in its PartySetting "FacReceivePutawayBetaAllow" (a CSV of
// facilityIds).
var parseFacilityCsv = function (csv) {
    return (csv !== null && csv !== void 0 ? csv : '')
        .split(',')
        .map(function (s) { return s.trim(); })
        .filter(Boolean);
};
export var isBetaFacility = function (csv, facilityId) {
    var _a;
    var fac = (_a = facilityId !== null && facilityId !== void 0 ? facilityId : localStorage.getItem('facilityId')) !== null && _a !== void 0 ? _a : '';
    return !!fac && parseFacilityCsv(csv).includes(fac);
};
export var useReceivingPutawayBetaGate = function () {
    var csv = useSelector(function (state) { var _a; return (_a = state === null || state === void 0 ? void 0 : state.auth) === null || _a === void 0 ? void 0 : _a.receivingPutawayBetaFacilityIds; });
    if (csv === undefined || csv === null) {
        var cached = localStorage.getItem('receivingPutawayBetaFacilityIds');
        if (cached === null)
            return 'loading';
        return isBetaFacility(cached) ? 'allowed' : 'denied';
    }
    return isBetaFacility(csv) ? 'allowed' : 'denied';
};
export var useHandheldBetaOnly = function () {
    var csv = useSelector(function (state) { var _a; return (_a = state === null || state === void 0 ? void 0 : state.auth) === null || _a === void 0 ? void 0 : _a.handheldBetaOnlyFacilityIds; });
    if (csv === undefined || csv === null) {
        return isBetaFacility(localStorage.getItem('handheldBetaOnlyFacilityIds'));
    }
    return isBetaFacility(csv);
};
// Beta-only hides a legacy screen only when its beta equivalent is actually
// available at this facility: the receiving family needs the receiving/put-away
// beta gate, packing beta is available everywhere.
export var useScreenVisibility = function () {
    var betaOnly = useHandheldBetaOnly();
    var receivingBetaAllowed = useReceivingPutawayBetaGate() === 'allowed';
    return {
        showLegacyReceivingFamily: !(betaOnly && receivingBetaAllowed),
        showLegacyPacking: !betaOnly
    };
};
// No Click DTC (auto-complete)
// "NoClickDtcShippingBeta" / "NoClickDtcPackingSlip", both default off. Not
// loaded yet == off — the feature stays dark rather than showing a loading state.
var useOrgBooleanGate = function (stateKey) {
    var value = useSelector(function (state) { var _a; return (_a = state === null || state === void 0 ? void 0 : state.auth) === null || _a === void 0 ? void 0 : _a[stateKey]; });
    if (value === undefined || value === null)
        return localStorage.getItem(stateKey) === 'true';
    return value === true;
};
/** Owner org is in the No Click DTC beta: auto-complete flow + save-default checkbox. */
export var useNoClickDtcBetaEnabled = function () { return useOrgBooleanGate('noClickDtcBetaEnabled'); };
/** Owner org opted in to auto-printing the packing slip during auto-complete. */
export var useNoClickDtcPackingSlipEnabled = function () {
    return useOrgBooleanGate('noClickDtcPackingSlipEnabled');
};
